import React, { useState } from 'react';
import { PopupModal } from '../../../Modals/Index';
import FilterVintageIcon from '@material-ui/icons/FilterVintage';
import ViewArrayIcon from '@material-ui/icons/ViewArray';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import QueuePlayNextIcon from '@material-ui/icons/QueuePlayNext';
import FlareIcon from '@material-ui/icons/Flare';
import PrintIcon from '@material-ui/icons/Print';
import PrintMockup from '../PrintMockup/PrintMockup';
const Index = ({ state, setStateFalse }) => {
    const [selected, setSelected] = useState(-1);
    const [popup, setPopup] = useState(false);
    return (
        <>
            <PrintMockup
                state={popup}
                setStateFalse={() => {
                    setPopup((prev) => !prev);
                }}
            />
            <PopupModal setStateFalse={setStateFalse} state={state}>
                <div className="popupConatiner">
                    <div className="home_head">
                        <h2 className="home_heading">Choose Print Type</h2>
                    </div>
                    <div className="popup_body">
                        <div className="big_icons_container">
                            <div
                                onClick={() => {
                                    setSelected(1);
                                }}
                                className={`big-icons_item ${selected === 1 ? 'active' : ''}`}
                            >
                                <div>
                                    <QueuePlayNextIcon className="big-icons_icon" />
                                    <p className="big-icons_text">Screen Print Design</p>
                                </div>
                            </div>
                            <div
                                onClick={() => {
                                    setSelected(2);
                                }}
                                className={`big-icons_item ${selected === 2 ? 'active' : ''}`}
                            >
                                <div>
                                    <FlareIcon className="big-icons_icon" />
                                    <p className="big-icons_text">Sublimation Print Design</p>
                                </div>
                            </div>
                            <div
                                onClick={() => {
                                    setSelected(3);
                                }}
                                className={`big-icons_item ${selected === 3 ? 'active' : ''}`}
                            >
                                <div>
                                    <PrintIcon className="big-icons_icon" />
                                    <p className="big-icons_text">Digital print design</p>
                                </div>
                            </div>
                            <div
                                onClick={() => {
                                    setSelected(4);
                                }}
                                className={`big-icons_item ${selected === 4 ? 'active' : ''}`}
                            >
                                <div>
                                    <FilterVintageIcon className="big-icons_icon" />
                                    <p className="big-icons_text">Vinly Print Design</p>
                                </div>
                            </div>
                            <div
                                onClick={() => {
                                    setSelected(5);
                                }}
                                className={`big-icons_item ${selected === 5 ? 'active' : ''}`}
                            >
                                <div>
                                    <ViewArrayIcon className="big-icons_icon" />
                                    <p className="big-icons_text">UV Print Design</p>
                                </div>
                            </div>
                        </div>
                        <div className="footer_button">
                            <button style={{ marginRight: '2rem' }} onClick={setStateFalse} className="btn-gray">
                                <KeyboardBackspaceIcon className="btn-icon " />
                                <p>Back</p>
                            </button>
                            <button
                                onClick={() => {
                                    setStateFalse();
                                    setPopup((prev) => !prev);
                                }}
                                disabled={selected === -1}
                                className="btn-orange "
                            >
                                <p>Proceed</p>
                            </button>
                        </div>
                    </div>
                </div>
            </PopupModal>
        </>
    );
};

export default Index;
